import React from 'react'
import PropTypes from 'prop-types'

const Message = ({title, message, type = 'widget_message', time}) => {
  return (
    <div className={`message ${type}`} data-block-type='6'>
      {title && <span className="title-message">{title ? title.split('/:')[0] : ''}</span>}
      <span className="text-message" dangerouslySetInnerHTML={{__html: message}}></span>
      {time && <span className='message-time'>{time}</span>}
    </div>
  )
}

Message.propTypes = {
  message: PropTypes.string.isRequired,
  type: PropTypes.string,
  title: PropTypes.string,
}

export default Message